<template>
    <div></div>
</template>

<script>
export default {
    name: 'Basket',
    props : {
        warningMsg : {
            type : String,
            default : '',
        },
        errorMsg : {
            type : String,
            default : '',
        },
        ordersDisabledMsg : {
            type : String,
            default : '',
        },
        chooseShopMsg : {
            type : String,
            default : '',
        },
        shareCartUrl : {
            type : String,
            default : '',
        },
        shareCartInfo : {
            type : String,
            default : '',
        },
        totalFormatted : {
            type : String,
            default : '',
        },
        total : {
            type : Number,
            default : 0,
        },
        items : {
            type : Array,
            default : () => ([]),
        },
        storesDelivery : {
            type : Object,
            default : () => ({}),
        },
        checkKorpOrder : { //замена
          type : String,
          default : '',
        },
    },
    created(){

    },
    computed : {
        getShareCartUrlData() {
            return this.shareCartUrlData;
        },
        getShareCartUrl() {
            return this.shareCartInfoData;
        },
        mainShop () {
            return vxCommonStore.state.mainShop;
        },
        cartData () {
            var tare = [];
            if (this.tareSum) {
                for (var i = 0; i < this.itemsProp.length; i++) {
                    if (this.itemsProp[i].isDraftBeer && !this.itemsProp[i].delay) {
                        var item = {
                            baseCartId : +this.itemsProp[i].cartId,
                            baseProductId : +this.itemsProp[i].productId,
                            items : [],
                        };
                        for (var j = 0; j < this.itemsProp[i].tareItems.length; j++) {
                            if (+this.itemsProp[i].tareItems[j].quantity) {
                                item.items.push({
                                    volume : this.itemsProp[i].tareItems[j].volume,
                                    productId : +this.itemsProp[i].tareItems[j].productId,
                                    quantity : +this.itemsProp[i].tareItems[j].quantity,
                                });
                            }
                        }
                        tare.push(item);
                    }
                }
            }
            var cartData = {
                tareSum : this.tareSum,
                tare,
            };
            return cartData;
        },
        catalogUploadDate(){
            return moment.unix(vxCommonStore.state.catalogUploadTimestamp).format('H:mm МСК от DD.MM.YYYY');
        },
        favoriteProducts : () => vxCommonStore.state.favoriteProducts,
        totalSum () {
            return _.round((this.sum + this.tareSum), 2);
        },
        tareSum () {
            var sum = 0;
            if(this.itemsProp.length)
              {
                for( var i=0; i < this.itemsProp.length; i++ )
                  {
                    if( this.itemsProp[ i ].isDraftBeer && !this.itemsProp[ i ].delay )
                      {
                        var item=this.itemsProp[ i ];
                        for( var j=0; j < item.tareItems.length; j++ )
                          {
                            if( +item.tareItems[ j ].price )
                              {
                                sum+=+item.tareItems[ j ].quantity * +item.tareItems[ j ].price;
                              }
                          }
                      }
                  }
              }
            return sum;
        },
        itemsAvailable () {
            //return this.itemsProp.filter(item => !item.delay && (item.storeAmount || item.shopAmount));
            return this.itemsProp.filter(
                item => !item.delay && (item.storeAmount || item.shopAmount || this.$store.state.corpOrder == "Y")
            ); //замена
        },
        itemsDelayed () {
            if(this.itemsProp.length)
              {
                return this.itemsProp.filter(item => item.delay);
              }else{
                return false;
            }
        },
        itemsGrouped () {

            for (var i = 0; i < this.itemsAvailable.length; i++) {
              let item = this.itemsAvailable[i];
              let maxQ = parseInt(item.shopAmount) + parseInt(item.storeAmount);
              //для корпоративных делаем максимальное из максимального параметра, а не остаткам
              if(this.$store.state.corpOrder == "Y"){
                maxQ = item.maxQuantityNotShop;
              }
              if(maxQ < parseInt(item.quantity)){
                item.quantity = maxQ;
                this.cartChangeQuantity(item);
              }
            }

            let itemsGrouped = {};
            for (var i = 0; i < this.itemsAvailable.length; i++) {
                let item = this.itemsAvailable[i];
                if(this.$store.state.corpOrder == "Y"){item.shopAmount = item.maxQuantityNotShop;}
                let shopQuantity = item.quantity < item.shopAmount ? item.quantity : item.shopAmount;
                let items = {};
                let storeId = 'shop';
                if (item.quantity > shopQuantity) {
                    storeId = item.storeId;
                }

                if (!itemsGrouped[ storeId ]) {
                    itemsGrouped[ storeId ] = {
                        items : [],
                        sum : 0,
                        storeId,
                        deliveryDate : this.storesDelivery[ storeId ] ? this.storesDelivery[ storeId ].deliveryDate : '',
                        deliveryDateFormatted : this.storesDelivery[ storeId ] ? this.storesDelivery[ storeId ].deliveryDateFormatted : '',
                    };
                }
                if (+item.price) {
                    item.sum = +item.price * +item.quantity;
                    itemsGrouped[ storeId ].sum += item.sum;
                }
                itemsGrouped[ storeId ].items.push( item );
            }

            return Object.values(itemsGrouped).sort( (a, b) => (a.storeId == 'shop' ? 0 : 10) - (b.storeId == 'shop' ? 0 : 10) );
        },
      minOrderSum()
        {
          //console.log(this.$store,'this.$store');
          if( _.isEmpty(vxCommonStore.state.shopsData) )
            {
              vxCommonStore.commit("loadShops");
            }

          return 500;
        },
    },
    data : () => ({
        itemsProp : [],
        totalFormattedProp : '',
        sum : 0,
        ajaxProcessed : false,
        shareCartUrlData : null,
        shareCartInfoData : null,
    }),
    watch : {
      //при ищменении мы знаем, что это корректный инн и он уже применился
        '$store.state.corpOrderInn'(inn){
          this.update();
        },
        cartData (val, oldVal) {
            vxCommonStore.commit('setCartData', val);
        },
        itemsDelayed (items) {
            if (items.length && !this.$store.state.cartHasUnavailableProducts) {
                this.$store.commit('setCartHasUnavailableProducts', true);
            }
            if (!items.length && this.$store.state.cartHasUnavailableProducts) {
                this.$store.commit('setCartHasUnavailableProducts', false);
            }
        },
        itemsGrouped (itemsGrouped) {
            this.$store.commit('setCartItemsData', itemsGrouped);
        },
        totalSum (totalSum) {
            this.$store.commit('setCartTotal', totalSum);
        },
        itemsProp : {
            handler (items, oldVal) {
                // проверяем, есть ли в корзине среди не отложенных товаров такие,
                // количество которых в текущем магазине равно 0
                // и если есть - вызываем функцию пересчёта количества для произвольного товара
                // для пересчёта корзины
                let item = items.find(o => !o.delay && !o.shopAmount);
                // if (this.mainShop.id && item) {
                //     this.cartChangeQuantity(item);
                // }
            },
            deep : true,
        },
    },
    mounted () {
        this.itemsProp = this.items;
        this.tareRecalc();
        this.totalFormattedProp = this.totalFormatted;
        this.sum = +this.total;
        $(() => {
            if (vxCommonStore.state.isOrdersDisabled) {
                vmApp.showOrdersDisabledPopup();
            }
        });
      if (this.checkKorpOrder)
        this.$store.commit("setCorpOrder", this.checkKorpOrder);

        this.shareCartUrlData = this.shareCartUrl;
        this.shareCartInfoData = this.shareCartInfo;
    },
    updated(){
      $(".product_row_b_price").each((i, el) => {
          let $this = $(el);

          $this.closest(".product_row_right")
            .find(".product_row__tare-item-volume")
              .outerWidth($this.outerWidth());
        });
    },
    methods : {
        scrollToOrderForm () {
      		$('html,body').animate({
            	scrollTop: $('.bl_basket_order').offset().top - 20
      			},
                700
      		);
        },
        favToggle (productId) {
            if (!~this.favoriteProducts.indexOf(+productId)) {
                vxCommonStore.commit('addFavoriteProduct', productId);
            }
            else {
                vxCommonStore.commit('deleteFavoriteProduct', productId);
            }
        },
        getItemClasses (item) {
            var classes = [];
            classes.push('product');
            classes.push('basket_product');
            classes.push('product--' + item.productId);
            if (~this.favoriteProducts.indexOf(+item.productId)) {
                classes.push('product--favorite');
            }
            if (item.storeAmount && item.quantity >= item.storeAmount) {
                classes.push('product--amount-limit');
            }
            if (item.calcItem) {
                classes.push('basket_product--calc');
            }
            if (this.mainShop.id && item.quantity > item.storeAmount) {
                classes.push('basket_product--quantity-exceeded');
            }
            if (item.discountPrice) {
                classes.push('product--discount');
            }
            if (item.isYellow) {
                classes.push('product--yellow');
            }
            return classes;
        },
        showShopSelect(options){
            var options = options || {};
            vmApp.showShopSelect(options);
        },
        downloadPdf () {
            if (typeof(window.yaCounter15466654) != 'undefined') {
                window.yaCounter15466654.reachGoal('saveaspdf');
            }
        },
        shareCartEmail () {
            $.fancybox({
                href : '#share_cart_mail_form_container',
            });
        },
        print () {
            if (typeof(window.yaCounter15466654) != 'undefined') {
                window.yaCounter15466654.reachGoal('print');
            }
            var w = window.open('', '_blank');
            XPage.ajax({
                data : {
                    'ajax_command' : 'getCartPdf',
                    'cartInfo' : this.shareCartInfo,
                },
                success : response => {
                    try {
                        if (response.filename) {
                            w.location = response.filename;
                            w.focus();
                            setTimeout(
                                () => {
                                    w.print();
                                },
                                2000
                            );
                            // $("#usercartPrintFrame").remove();
                            // $('<iframe>', {
                            //     src: response.filename,
                            //     id:  'usercartPrintFrame',
                            //     name:  'usercartPrintFrame',
                            //     frameborder: 0,
                            //     scrolling: 'no'
                            // }).css('display', 'none').appendTo('body');
                            // $("#usercartPrintFrame").get(0).contentWindow.print();
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
        },
        deleteItem (itemCartId) {

            var data = {};
            data['ajax_command'] = 'delete_cart_item';
            data['item_id'] = itemCartId;
            XPage.ajax({
                data : data,
                success : response =>
                {
                  this.update;
                  if(this.$parent.$refs.basket)
                    {
                      this.$parent.$refs.basket.update();
                    }
                }
            });
        },
        clearCart(){
          var data = {};
          data['ajax_command'] = 'clear_cart';
          XPage.ajax({
            data : data,
            success : response => {
              this.update();
              if(this.$parent.$refs.basket)
                {
                  this.$parent.$refs.basket.update();
                }
            },

          });


        },
        tareRecalc () {
            for (var i = 0; i < this.itemsProp.length; i++) {
                if (this.itemsProp[i].isDraftBeer && !this.itemsProp[i].delay) {
                    var item = this.itemsProp[i];
                    var itemQuantity = +item.quantity;
                    for (var j = 0; j < item.tareItems.length; j++) {
                        var tare = item.tareItems[j];
                        var volume = +tare.volume;
                        var tareQuantity = parseInt(itemQuantity / volume);
                        if ((itemQuantity - (tareQuantity * volume)) % 1 > 0) {
                            tareQuantity--;
                        }
                        if (tareQuantity > 0) {
                            tare.quantity = tareQuantity;
                            itemQuantity -= tareQuantity * +tare.volume;
                        }
                        else {
                            tare.quantity = 0;
                        }
                    }
                }
            }
        },
        cartChangeQuantity (item, isTare = false) {
            if (isTare) {
                var tareTotalQty = _.sumBy(item.tareItems, tare => +tare.quantity * +tare.volume);
                if (item.quantity != tareTotalQty) {
                    if (!tareTotalQty) {
                        item.tareItems[0].quantity = 1;
                        item.quantity = +item.tareItems[0].quantity * +item.tareItems[0].volume;
                    }
                    else {
                        item.quantity = tareTotalQty;
                    }
                }
            }
            clearTimeout(window.itemQuantityChangedTimeout);
            window.itemQuantityChangedTimeout = setTimeout(
                () => {
                    this.ajaxProcessed = true;
                    var data = {};
                    data.ajax_command = 'cart_change';
                    data.CART_ITEM = {};
                    let quantity = item.quantity;
                    data.CART_ITEM[item.cartId] = {
                        QUANTITY : quantity,
                    };
                    XPage.ajax({
                        data : data,
                        success : response => {
                            this.ajaxProcessed = false;
                            this.update();
                            // this.$root.$refs.basketline.update();
                        }
                    });
                },
                400
            );
        },
        update () {

            this.ajaxProcessed = true;
            var data = {};
            data['ajax_command'] = 'update_basket';
            XPage.ajax({
                data : data,
                success : response => {
                  if (typeof(response.data) != 'undefined') {
                    if(!response.data.items || (  Array.isArray(response.data.items) && response.data.items.length===0))
                      {
                          window.location.reload();
                      }

                    this.ajaxProcessed = false;
                        var item, curItem;
                        for (var i = 0; i < response.data.items.length; i++) {
                            item = response.data.items[i];
                            if (item.isDraftBeer) {
                                curItem = _.find(this.itemsProp, { cartId : item.cartId });
                                if (curItem && item.tareItems) {
                                    for (var j = 0; j < item.tareItems.length; j++) {
                                        item.tareItems[j].quantity = curItem.tareItems[j].quantity;
                                    }
                                }
                            }
                        }
                        this.itemsProp = response.data.items;
                        this.totalFormattedProp = response.data.totalFormatted;
                        this.sum = +response.data.total;
                        //window.vxCommonStore.commit('setCartTotal', this.sum);
                        this.$root.$refs.basketline.update();
                        this.updateShare();
                    }
                }
            });
        },
        updateShare()
            {
                let body = new FormData;
                body.append("ajax_command", "getShareAjax");
                body.append("z", "1");
                fetch(location.href, {
                    method: 'POST',
                    body
                })
                    .then(response => response.json())
                    .then(json => {
                        if(json.strCartShareInfo){
                            this.shareCartInfoData = json.strCartShareInfo;
                        }
                        if(json.shareCartUrl){
                            this.shareCartUrlData = json.shareCartUrl;
                        }
                    });
            },
        priceMouseOver(item){
            if (item.isYellow) {
                clearTimeout(window.hideHeaderMessageTimer);
                showHeaderMessage('Товары с желтым ценником &ndash; это очень-очень выгодно! Скидка по дисконтной карте не действует.', 'yellow', 99999);
            }
        },
        priceMouseLeave(){
            window.hideHeaderMessageTimer = setTimeout(function(){
                hideHeaderMessage();
            }, 3000);
        },
    },
}
</script>
